module.exports = __webpack_public_path__ + "img/Dkterma-1138-655-305.55857c30.jpg";